<template>
  <v-layout column>
    <object-form-activities-tab-navbar>
      <v-btn x-small text icon color="accent" @click="exitTaskCreate">
        <v-icon>arrow_back_ios</v-icon>
      </v-btn>

      <v-flex class="subheading font-weight-bold">
        {{ $t("NewTask") }}
      </v-flex>

      <list-edition-toolbar
        :buttons="toolbarButtons"
        @save="scheduleDateFilled"
        horizontal-alignment="right"
      />

      <toggle-buttons
        v-model="mode"
        :buttons="toggleButtons"
        style="margin: 6px 8px"
      />
    </object-form-activities-tab-navbar>

    <task-create-form
      v-show="mode === 'details'"
      :new-task="newTask"
      :object-layer="objectLayer"
      :objectData="objectData"
      :dependency-options="dependenciesOptions"
    />
    <app-dialog-box
      :open="warningDialog"
      :title="$t('Warning')"
      :content="$t('TaskWarning')"
      :main-action-label="$t('No')"
      @mainAction="warningDialog = false"
      :secondary-action-label="$t('Yes')"
      @secondaryAction="confirmWarning"
    />
    <app-dialog-box
      :open="warningDialogUser"
      :title="$t('Warning')"
      :content="$t('TaskMissingUser')"
      :main-action-label="$t('No')"
      @mainAction="warningDialogUser = false"
      :secondary-action-label="$t('Yes')"
      @secondaryAction="confirmWarningUser"
    />
  </v-layout>
</template>

<script>
import { mapActions } from "vuex";
import ObjectFormActivitiesTabNavbar from "@/components/Home/Forms/_SpecialTabs/Activities/ActivitiesTabNavbar";
import InputField from "@/components/Home/Forms/_Molecules/InputField";
import ListEditionToolbar from "@/components/Home/Forms/_Molecules/ListEditionToolbar";
import TaskCreateForm from "./TaskCreateForm";
import ToggleButtons from "@/components/_Atoms/AppToggleButtons";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";

export default {
  name: "ObjectFormTaskCreate",

  components: {
    ToggleButtons,
    TaskCreateForm,
    ListEditionToolbar,
    InputField,
    ObjectFormActivitiesTabNavbar,
    AppDialogBox
  },

  props: {
    activityUuid: String,
    objectLayer: String,
    /**
     * clicked object data
     */
    objectData: Object
  },
  data() {
    return {
      newTask: {
        dependencies: [],
        title: undefined,
        description: null,
        user_assignee_id: null,
        scheduled_date: null,
        execution_time: null,
        type: null,
        /**
         * default mode of task auto_approval is true (auto approved)
         */
        auto_approval: true,
        content: []
      },
      dependenciesOptions: [],
      warningDialog: false,
      warningDialogUser: false,

      mode: "details"
    };
  },

  computed: {
    toolbarButtons() {
      return [
        {
          id: "save",
          icon: "save",
          tooltip: this.$i18n.t("Save"),
          active: true,
          disabled: !this.disableSave
        }
      ];
    },
    toggleButtons() {
      return [
        { value: "details", text: this.$i18n.tc("Detail", 2) }
        //{ value: "content", text: this.$i18n.t("Map"), disabled: true }
      ];
    },
    /**
     * Disables save button when items not filled.
     */
    disableSave() {
      return (
        !!this.newTask.title &&
        !!this.newTask.type &&
        !this.newTask.content.length <= 0
      );
    }
  },
  mounted() {
    this.getDependencies();
  },
  methods: {
    ...mapActions(["addTask", "fetchTasksByActivityUuid"]),

    exitTaskCreate() {
      this.$emit("close");
    },
    /**
     * if there is no scheduled date user is prompted
     * if there is a scheduled date and no user assigned user is prompted to assign
     * if all are filled a task is created
     */
    scheduleDateFilled() {
      if (!this.newTask.scheduled_date) {
        this.warningDialog = true;
        return;
      }
      if (!this.newTask.user_assignee_id) {
        this.warningDialogUser = true;
        return;
      }
      this.save();
    },
    async getDependencies(){
      const dependencies = await this.fetchTasksByActivityUuid({ uuid: this.activityUuid });
      dependencies.data.forEach(element => {
        this.dependenciesOptions.push({
          id: element.uuid,
          label: element.title
        });
      });
    },
    /**
     * if there is a user assigned and user wishes to save without scheduled date a task is created
     * else if the is no assigned user and user continues with no scheduled date, a new prompt appears warning there is no user assigned
     */
    confirmWarning() {
      if (this.newTask.user_assignee_id) {
        this.save();
      } else {
        this.warningDialogUser = true;
      }
      this.warningDialog = false;
    },

    /**
     * if user confirms there is no user assigned a task is created.
     */
    confirmWarningUser() {
      this.warningDialogUser = false;
      this.save();
    },

    async save() {
      if (!this.newTask.description) {
        delete this.newTask.description;
      }
      if (!this.newTask.user_assignee_id) {
        delete this.newTask.user_assignee_id;
      }
      //if time estimation exists, convert it to integer
      if(this.newTask.execution_time){
        this.newTask.execution_time = +this.newTask.execution_time;
      }else{
        //avoid sending empty string to BE
        this.newTask.execution_time = null;
      }
      try {
        this.loading = true;
        this.newTask.content.forEach(item =>{
          item.index = Number(item.index);
        });
        await this.addTask({
          activityUUID: this.activityUuid,
          newTaskData: this.newTask
        });
        this.exitTaskCreate();
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.task-form-container {
  border-radius: 2px;
  box-shadow: -0.5px 0.5px 2px rgba(0, 0, 0, 0.5);
  padding-top: 10px;
  padding-bottom: 20px;
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/TaskCreate/TaskCreate.vue